import React from 'react';
import { Button, Col, Row, Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { ResourcePublicLayout, ResourceContent } from '../components';
import { navigateToLogin } from '../redux';
import { ACCESS_URL, RESOURCES_URL, getConfigurationDataKey } from '../utils';
import { rawSafeHtmlProps } from '../utils';

export const RegistrationSubmitView = () => {
  const dispatch = useDispatch();
  return (
    <ResourcePublicLayout contentKey={getConfigurationDataKey('registration.submitted.title')} customHeader={true}>
      <Row className='align-items-start'>
        <Col lg={6}>
          <ResourceContent
            contentKey={getConfigurationDataKey('registration.submitted.body')}
            sourceDataKey='content'
            render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
          />
          <div className='text-right'>
            <Button variant='secondary' onClick={() => dispatch(navigateToLogin())}>
              Back to Homepage
            </Button>
          </div>
        </Col>
        <Col lg={3} />
        <Col lg={3} sm={5} className='d-flex flex-column align-items-start' style={{ marginTop: '-43px' }}>
          <Alert variant='success' style={{ width: 'max-content', height: 'fit-content' }}>
            <ResourceContent
              contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
              sourceDataKey='content'
              render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
            />
            <table className='mb-4'>
              <tbody>
                <tr>
                  <th>Phone:</th>
                  <td className='pl-4'>
                    <ResourceContent
                      contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                      sourceDataKey='phone'
                      render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                    />
                  </td>
                </tr>
                <tr>
                  <th className='pt-2'>Fax:</th>
                  <td className='pl-4 pt-2'>
                    <ResourceContent
                      contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                      sourceDataKey='fax'
                      render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <p className='mb-0'>
              <ResourceContent
                contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                sourceDataKey='hours'
                render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
              />
            </p>
          </Alert>
        </Col>
      </Row>
    </ResourcePublicLayout>
  );
};
